/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

const PracticeTemplateApi = {
  public: {},
  private: {
    /**
     * To fetch all practice clinics
     * @param {*} templateTypeId
     * @param {*} templateCategoryId
     * @returns
     */
    fetch: ({ templateCategoryId, practiceId }) => ProtectedHttpClient.get(`/practice/template/list/${templateCategoryId}/${practiceId}`),
    /**
     *  To delete a practice template by id
     * @param {*} templateId
     * @returns
     */
     delete: (templateId) => ProtectedHttpClient.post(`/template/delete/${templateId}`),
  }
};
export default PracticeTemplateApi;
